import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"

import economyReducers from "../reducers"

// Wear something already owned. PUT rather than POST on the same URL: same noun, and the only
// difference from buying is whether it is owned yet — which the server decides either way.
//
// Only the id is sent. Which slot it fills and which side it is worn on come from the cosmetic's
// own definition on the server, so a client cannot put a zombie sprite in the human slot.
export const thunk = createAsyncThunk(
  "economy/equipCosmetic",
  async ({ cosmetic }, { rejectWithValue }) => {
    try {
      const response = await apiClient.put("/shop/cosmetics/", { cosmetic })
      return {
        cosmetics: response.data.cosmetics,
        equippedCosmetics: response.data.equipped_cosmetics,
      }
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

export const onSucceed = economyReducers.setData

const thunkObject = { thunk, onSucceed }
export default thunkObject
